import { apiUserNeeds } from '@spo/services/api';
import { useQuery } from '@tanstack/react-query';

export const useNeedAndSegmentation = (
  userNeedId: number | undefined,
  userSegId: number | undefined,
) => {
  return useQuery({
    queryKey: ['useNeedAndSegmentation', userNeedId, userSegId],
    queryFn: async ({ signal }) => {
      if (!signal?.aborted && userNeedId && userSegId) {
        const response = apiUserNeeds.fetchNeedAndSegmentation({
          userNeedId,
          userSegId,
          userLanguage: 'EN',
        });
        return response;
      }
    },
  });
};
